import {
  NEW_PATIENT_DETAILS_SUCCESS,
  NEW_PATIENT_DETAILS_FAILURE,
} from './types';
import { logger } from '../logger';

const log = logger();

const newPatientDetails = (patient) => async (dispatch) => {
  try {
    dispatch({
      type: NEW_PATIENT_DETAILS_SUCCESS,
      payload: patient,
    });
  } catch (err) {
    log.error('Error dispatching new patient details', err);
    dispatch({
      type: NEW_PATIENT_DETAILS_FAILURE,
      payload: err,
    });
  }
};

export default newPatientDetails;
